<template>
    <div class="class-list-wrap">
        <h1 class="dq-list-title">西点系列</h1>
        <classList :getData="postData"></classList>
    </div>
</template>

<script>
import classList from "@/components/ClassList"
export default {
    name: 'dessertFood',
    data(){
        return{
            postData: {
                type: 1,
                path: '/dqlist/DessertFood/'
            }
        }
    },
    components: {
        classList
    }
}
</script>

<style lang="less" scoped>
@rem: 40rem;
@w100: 640/@rem;
.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.auto(@w) {
    width: @w/@rem;
    margin: 0 auto;
}
// 圆角
.radius(@radius) {
    border-radius: @radius/@rem @radius/@rem @radius/@rem @radius/@rem;
}
.linefont(@lineHeight, @fontSize, @color) {
    line-height: @lineHeight/@rem;
    font-size: @fontSize/@rem;
    color: @color;
}
.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}
.aimg(@h) {
    a {
        display: block;

        img {
            width: 100%;
            height: @h/@rem;
        }
    }
}
// vue闪烁问题
[v-cloak] {
    display: none;
}
.dq-list-title{
    .linefont(66, 30, #000);
}
</style>